import { getRequest, postRequest } from "../app/postRequest.service";
import { BaseResponse } from "../interfaces/claimList.interface";
import { EncryptedClaimIdResponse, EncryptedDataResponse, IntimationCheckRequest } from "../interfaces/master.interface";

export function checkIntimationId(req: IntimationCheckRequest) {
  return new Promise<{ data: BaseResponse }>((resolve) =>
    resolve(postRequest(`/master/intimationExist`,req))
  );
}